export default "__VITE_ASSET__N68XgwKU__"